import sleep from 'utils/sleep'
import { OperationError } from '../common/error'

export let list = async => [
  {
    title: '2017-2018学年度"优秀教师评选1"',
    status: '1',
    department: '教育部',
    admin: '我',
    content: '梦想雄鹰的翅膀，\n梦想超越的辉煌，却发现我的翅膀早已给了我的学生。在每一次雏鹰展翅的试飞里，我听见理想扣击天堂的回响。这就是我 ---一名普通小学语文教师兼班主任。我于xx年9月参加工作，至今已经整整13年了。在这13年的时间里，我把满腔的热血献给了我挚爱的孩子们，把勤劳和智慧融入这小小的三尺讲台，使这块儿沃土上的花儿茁壮成长，竞相绽放。下面，结合自身这一年的辛勤工作，谈一谈认识和体会',
    attachment: '',
    receiver: ['教师', '管理', '校长', '教育部', '校长办公室'],
    pubdate: '2018-4-5',
    uid: '100',
  },
  {
    title: '2016-2017学年度"优秀教师评选2"',
    status: '0',
    department: '校长办公室',
    admin: '你',
    content: '我热爱自己的工作，\n 如同热爱自己的生命。早在孩提时代，教师的圣洁和崇高品质就在我的心中根深蒂固。那时，就在心中萌发了当一名人民教师的愿望。大学毕业后，梦想成真，我成为一名光荣的人民教师。站在神圣的讲台上，我不曾忘记自己的誓言，不曾动摇过这颗育人的拳拳之心。凭着这种对教育的赤诚之心和强烈的责任感，我在平凡的教学工作中永远保持着一种崇高的敬业精神、忘我的牺牲精神、无私的奉献精神。我告诉自己要用心地做教育中的每一件小事、耐心地处理班级里的每个问题、用全部的爱呵护着每一颗幼小的心灵。我播种阳光，收获了春天。学生才是我最好的荣誉证书。所以，我面对世人的不解不曾退却；面对众多的诱惑不曾动摇；面对雏鹰般跃跃欲飞的学生，我依然风里雨里、脚步坚定、豪情满怀！',
    attachment: '',
    receiver: ['教师', '管理', '校长', '教育部', '校长办公室'],
    pubdate: '2017-3-7',
    uid: '101',
  },
  {
    title: '2016-2017学年度"优秀教师评选3"',
    status: '0',
    department: '校长办公室',
    admin: '你',
    content: '我热爱自己的工作， 如同热爱自己的生命。早在孩提时代，教师的圣洁和崇高品质就在我的心中根深蒂固。那时，就在心中萌发了当一名人民教师的愿望。大学毕业后，梦想成真，我成为一名光荣的人民教师。站在神圣的讲台上，我不曾忘记自己的誓言，不曾动摇过这颗育人的拳拳之心。凭着这种对教育的赤诚之心和强烈的责任感，我在平凡的教学工作中永远保持着一种崇高的敬业精神、忘我的牺牲精神、无私的奉献精神。我告诉自己要用心地做教育中的每一件小事、耐心地处理班级里的每个问题、用全部的爱呵护着每一颗幼小的心灵。我播种阳光，收获了春天。学生才是我最好的荣誉证书。所以，我面对世人的不解不曾退却；面对众多的诱惑不曾动摇；面对雏鹰般跃跃欲飞的学生，我依然风里雨里、脚步坚定、豪情满怀！',
    attachment: '',
    receiver: ['教师', '管理', '校长', '教育部', '校长办公室'],
    pubdate: '2017-3-7',
    uid: '102',
  },
  {
    title: '2016-2017学年度"优秀教师评选4"',
    status: '0',
    department: '校长办公室',
    admin: '你',
    content: '我热爱自己的工作， 如同热爱自己的生命。早在孩提时代，教师的圣洁和崇高品质就在我的心中根深蒂固。那时，就在心中萌发了当一名人民教师的愿望。大学毕业后，梦想成真，我成为一名光荣的人民教师。站在神圣的讲台上，我不曾忘记自己的誓言，不曾动摇过这颗育人的拳拳之心。凭着这种对教育的赤诚之心和强烈的责任感，我在平凡的教学工作中永远保持着一种崇高的敬业精神、忘我的牺牲精神、无私的奉献精神。我告诉自己要用心地做教育中的每一件小事、耐心地处理班级里的每个问题、用全部的爱呵护着每一颗幼小的心灵。我播种阳光，收获了春天。学生才是我最好的荣誉证书。所以，我面对世人的不解不曾退却；面对众多的诱惑不曾动摇；面对雏鹰般跃跃欲飞的学生，我依然风里雨里、脚步坚定、豪情满怀！',
    attachment: '',
    receiver: ['教师', '管理', '校长', '教育部', '校长办公室'],
    pubdate: '2017-3-7',
    uid: '103',
  },
  {
    title: '2016-2017学年度"优秀教师评选5"',
    status: '0',
    department: '校长办公室',
    admin: '你',
    content: '我热爱自己的工作， 如同热爱自己的生命。早在孩提时代，教师的圣洁和崇高品质就在我的心中根深蒂固。那时，就在心中萌发了当一名人民教师的愿望。大学毕业后，梦想成真，我成为一名光荣的人民教师。站在神圣的讲台上，我不曾忘记自己的誓言，不曾动摇过这颗育人的拳拳之心。凭着这种对教育的赤诚之心和强烈的责任感，我在平凡的教学工作中永远保持着一种崇高的敬业精神、忘我的牺牲精神、无私的奉献精神。我告诉自己要用心地做教育中的每一件小事、耐心地处理班级里的每个问题、用全部的爱呵护着每一颗幼小的心灵。我播种阳光，收获了春天。学生才是我最好的荣誉证书。所以，我面对世人的不解不曾退却；面对众多的诱惑不曾动摇；面对雏鹰般跃跃欲飞的学生，我依然风里雨里、脚步坚定、豪情满怀！',
    attachment: '',
    receiver: ['教师', '管理', '校长', '教育部', '校长办公室'],
    pubdate: '2017-3-7',
    uid: '104',
  },
  {
    title: '2016-2017学年度"优秀教师评选6"',
    status: '0',
    department: '校长办公室',
    admin: '你',
    content: '我热爱自己的工作， 如同热爱自己的生命。早在孩提时代，教师的圣洁和崇高品质就在我的心中根深蒂固。那时，就在心中萌发了当一名人民教师的愿望。大学毕业后，梦想成真，我成为一名光荣的人民教师。站在神圣的讲台上，我不曾忘记自己的誓言，不曾动摇过这颗育人的拳拳之心。凭着这种对教育的赤诚之心和强烈的责任感，我在平凡的教学工作中永远保持着一种崇高的敬业精神、忘我的牺牲精神、无私的奉献精神。我告诉自己要用心地做教育中的每一件小事、耐心地处理班级里的每个问题、用全部的爱呵护着每一颗幼小的心灵。我播种阳光，收获了春天。学生才是我最好的荣誉证书。所以，我面对世人的不解不曾退却；面对众多的诱惑不曾动摇；面对雏鹰般跃跃欲飞的学生，我依然风里雨里、脚步坚定、豪情满怀！',
    attachment: '',
    receiver: ['教师', '管理', '校长', '教育部', '校长办公室'],
    pubdate: '2017-3-7',
    uid: '105',
  },
  {
    title: '2016-2017学年度"优秀教师评选7"',
    status: '0',
    department: '校长办公室',
    admin: '你',
    content: '我热爱自己的工作， 如同热爱自己的生命。早在孩提时代，教师的圣洁和崇高品质就在我的心中根深蒂固。那时，就在心中萌发了当一名人民教师的愿望。大学毕业后，梦想成真，我成为一名光荣的人民教师。站在神圣的讲台上，我不曾忘记自己的誓言，不曾动摇过这颗育人的拳拳之心。凭着这种对教育的赤诚之心和强烈的责任感，我在平凡的教学工作中永远保持着一种崇高的敬业精神、忘我的牺牲精神、无私的奉献精神。我告诉自己要用心地做教育中的每一件小事、耐心地处理班级里的每个问题、用全部的爱呵护着每一颗幼小的心灵。我播种阳光，收获了春天。学生才是我最好的荣誉证书。所以，我面对世人的不解不曾退却；面对众多的诱惑不曾动摇；面对雏鹰般跃跃欲飞的学生，我依然风里雨里、脚步坚定、豪情满怀！',
    attachment: '',
    receiver: ['教师', '管理', '校长', '教育部', '校长办公室'],
    pubdate: '2017-3-7',
    uid: '106',
  },
  {
    title: '2016-2017学年度"优秀教师评选8"',
    status: '1',
    department: '校长办公室',
    admin: '你',
    content: '我热爱自己的工作， 如同热爱自己的生命。早在孩提时代，教师的圣洁和崇高品质就在我的心中根深蒂固。那时，就在心中萌发了当一名人民教师的愿望。大学毕业后，梦想成真，我成为一名光荣的人民教师。站在神圣的讲台上，我不曾忘记自己的誓言，不曾动摇过这颗育人的拳拳之心。凭着这种对教育的赤诚之心和强烈的责任感，我在平凡的教学工作中永远保持着一种崇高的敬业精神、忘我的牺牲精神、无私的奉献精神。我告诉自己要用心地做教育中的每一件小事、耐心地处理班级里的每个问题、用全部的爱呵护着每一颗幼小的心灵。我播种阳光，收获了春天。学生才是我最好的荣誉证书。所以，我面对世人的不解不曾退却；面对众多的诱惑不曾动摇；面对雏鹰般跃跃欲飞的学生，我依然风里雨里、脚步坚定、豪情满怀！',
    attachment: '',
    receiver: ['教师', '管理', '校长', '教育部', '校长办公室'],
    pubdate: '2017-3-7',
    uid: '107',
  },
  {
    title: '2016-2017学年度"优秀教师评选9"',
    status: '0',
    department: '校长办公室',
    admin: '你',
    content: '我热爱自己的工作， 如同热爱自己的生命。早在孩提时代，教师的圣洁和崇高品质就在我的心中根深蒂固。那时，就在心中萌发了当一名人民教师的愿望。大学毕业后，梦想成真，我成为一名光荣的人民教师。站在神圣的讲台上，我不曾忘记自己的誓言，不曾动摇过这颗育人的拳拳之心。凭着这种对教育的赤诚之心和强烈的责任感，我在平凡的教学工作中永远保持着一种崇高的敬业精神、忘我的牺牲精神、无私的奉献精神。我告诉自己要用心地做教育中的每一件小事、耐心地处理班级里的每个问题、用全部的爱呵护着每一颗幼小的心灵。我播种阳光，收获了春天。学生才是我最好的荣誉证书。所以，我面对世人的不解不曾退却；面对众多的诱惑不曾动摇；面对雏鹰般跃跃欲飞的学生，我依然风里雨里、脚步坚定、豪情满怀！',
    attachment: '',
    receiver: ['教师', '管理', '校长', '教育部', '校长办公室'],
    pubdate: '2017-3-7',
    uid: '108',
  },
  {
    title: '2016-2017学年度"优秀教师评选10"',
    status: '1',
    department: '校长办公室',
    admin: '你',
    content: '我热爱自己的工作， 如同热爱自己的生命。早在孩提时代，教师的圣洁和崇高品质就在我的心中根深蒂固。那时，就在心中萌发了当一名人民教师的愿望。大学毕业后，梦想成真，我成为一名光荣的人民教师。站在神圣的讲台上，我不曾忘记自己的誓言，不曾动摇过这颗育人的拳拳之心。凭着这种对教育的赤诚之心和强烈的责任感，我在平凡的教学工作中永远保持着一种崇高的敬业精神、忘我的牺牲精神、无私的奉献精神。我告诉自己要用心地做教育中的每一件小事、耐心地处理班级里的每个问题、用全部的爱呵护着每一颗幼小的心灵。我播种阳光，收获了春天。学生才是我最好的荣誉证书。所以，我面对世人的不解不曾退却；面对众多的诱惑不曾动摇；面对雏鹰般跃跃欲飞的学生，我依然风里雨里、脚步坚定、豪情满怀！',
    attachment: '',
    receiver: ['教师', '管理', '校长', '教育部', '校长办公室'],
    pubdate: '2017-3-7',
    uid: '109',
  },
  {
    title: '2016-2017学年度"优秀教师评选11"',
    status: '1',
    department: '校长办公室',
    admin: '你',
    content: '我热爱自己的工作， 如同热爱自己的生命。早在孩提时代，教师的圣洁和崇高品质就在我的心中根深蒂固。那时，就在心中萌发了当一名人民教师的愿望。大学毕业后，梦想成真，我成为一名光荣的人民教师。站在神圣的讲台上，我不曾忘记自己的誓言，不曾动摇过这颗育人的拳拳之心。凭着这种对教育的赤诚之心和强烈的责任感，我在平凡的教学工作中永远保持着一种崇高的敬业精神、忘我的牺牲精神、无私的奉献精神。我告诉自己要用心地做教育中的每一件小事、耐心地处理班级里的每个问题、用全部的爱呵护着每一颗幼小的心灵。我播种阳光，收获了春天。学生才是我最好的荣誉证书。所以，我面对世人的不解不曾退却；面对众多的诱惑不曾动摇；面对雏鹰般跃跃欲飞的学生，我依然风里雨里、脚步坚定、豪情满怀！',
    attachment: '',
    receiver: ['教师', '管理', '校长', '教育部', '校长办公室'],
    pubdate: '2017-3-7',
    uid: '110',
  },
  {
    title: '2016-2017学年度"优秀教师评选12"',
    status: '0',
    department: '校长办公室',
    admin: '你',
    content: '我热爱自己的工作， 如同热爱自己的生命。早在孩提时代，教师的圣洁和崇高品质就在我的心中根深蒂固。那时，就在心中萌发了当一名人民教师的愿望。大学毕业后，梦想成真，我成为一名光荣的人民教师。站在神圣的讲台上，我不曾忘记自己的誓言，不曾动摇过这颗育人的拳拳之心。凭着这种对教育的赤诚之心和强烈的责任感，我在平凡的教学工作中永远保持着一种崇高的敬业精神、忘我的牺牲精神、无私的奉献精神。我告诉自己要用心地做教育中的每一件小事、耐心地处理班级里的每个问题、用全部的爱呵护着每一颗幼小的心灵。我播种阳光，收获了春天。学生才是我最好的荣誉证书。所以，我面对世人的不解不曾退却；面对众多的诱惑不曾动摇；面对雏鹰般跃跃欲飞的学生，我依然风里雨里、脚步坚定、豪情满怀！',
    attachment: '',
    receiver: ['教师', '管理', '校长', '教育部', '校长办公室'],
    pubdate: '2017-3-7',
    uid: '111',
  },
  {
    title: '2016-2017学年度"优秀教师评选13"',
    status: '1',
    department: '校长办公室',
    admin: '你',
    content: '我热爱自己的工作， 如同热爱自己的生命。早在孩提时代，教师的圣洁和崇高品质就在我的心中根深蒂固。那时，就在心中萌发了当一名人民教师的愿望。大学毕业后，梦想成真，我成为一名光荣的人民教师。站在神圣的讲台上，我不曾忘记自己的誓言，不曾动摇过这颗育人的拳拳之心。凭着这种对教育的赤诚之心和强烈的责任感，我在平凡的教学工作中永远保持着一种崇高的敬业精神、忘我的牺牲精神、无私的奉献精神。我告诉自己要用心地做教育中的每一件小事、耐心地处理班级里的每个问题、用全部的爱呵护着每一颗幼小的心灵。我播种阳光，收获了春天。学生才是我最好的荣誉证书。所以，我面对世人的不解不曾退却；面对众多的诱惑不曾动摇；面对雏鹰般跃跃欲飞的学生，我依然风里雨里、脚步坚定、豪情满怀！',
    attachment: '',
    receiver: ['教师', '管理', '校长', '教育部', '校长办公室'],
    pubdate: '2017-3-7',
    uid: '112',
  },
]

export let status = async => ({
  1: '已发布',
  0: '未发布',
})

export let form_all = async => [
  {name: '标题', required: true, type: 'string', prop: 'title'},
  {name: '发布部门', type: 'select', prop: 'department', select: ['教育部', '教务部', '校长办公室']},
  {name: '发布人', type: 'string', prop: 'admin'},
  {name: '发布时间', type: 'date', prop: 'pubdate'},
  {name: '内容', type: 'string', prop: 'content'},
  {name: '接收人', type: 'string', prop: 'receiver'},
  {name: '附件', type: 'file', prop: 'attachment'},
]

export let form_brief = async => [
  {name: '状态', required: true, type: 'string', prop: 'status'},
  {name: '标题', required: true, type: 'string', prop: 'title'},
  {name: '发布部门', type: 'select', prop: 'department', select: ['教育部', '教务部', '校长办公室']},
  {name: '发布人', type: 'string', prop: 'admin'},
  {name: '发布时间', type: 'date', prop: 'pubdate'},
  {name: '接收人', type: 'string', prop: 'receiver'},
]

export let form_preview = async => [
  {name: '发布部门', type: 'select', prop: 'department', select: ['教育部', '教务部', '校长办公室']},
  {name: '发布人', type: 'string', prop: 'admin'},
  {name: '内容', type: 'string', prop: 'content'},
  {name: '接收人', type: 'string', prop: 'receiver'},
]

export let form_create = async => [
  {name: '标题', required: true, type: 'string', prop: 'title'},
  {name: '发布部门', type: 'select', prop: 'department', select: ['教育部', '教务部', '校长办公室']},
  {name: '发布人', type: 'string', prop: 'admin'},
  {name: '内容', type: 'string', prop: 'content'},
  {name: '附件', type: 'file', prop: 'attachment'},
  {
    name: '接收人',
    type: 'select',
    prop: 'receiver',
    select: {'role': ['教师', '管理', '校长'], 'dept': ['教育部', '教务部', '校长办公室']},
  },
]

export let get = async uid => {
  let details = await list()
  for (let detail of details) {
    if (detail.uid === uid) return detail
  }
  return null
}

export let onlySave = async (notice, notice_uid) => {
  await sleep(500)
  if (notice_uid) {
    return notice_uid
  } else {
    throw new OperationError('保存错误')
  }
}

export let saveAndPublish = async (notice, notice_uid) => {
  await sleep(500)
  if (notice_uid) {
    return notice_uid
  } else {
    throw new OperationError('保存并发布错误')
  }
}

export let cancelOrDelete = async (notice, notice_uid) => {
  await sleep(500)
  if (notice_uid) {
    return notice_uid
  } else {
    throw new OperationError('删除错误')
  }
}



// WEBPACK FOOTER //
// ./src/api/notice.js